import { Box, Grid, Skeleton, Theme, useMediaQuery } from '@mui/material';
import { moduleCardStyles } from '../../theme/styles/moduleCard';

export const RoutineCardSkeleton = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  return (
    <Box sx={[moduleCardStyles.card, { p: 3 }]}>
      <Box sx={{ mb: 3 }}>
        <Grid container alignItems="center" flexWrap="nowrap" spacing={1}>
          <Grid item sx={moduleCardStyles.imgContainer}>
            <Skeleton variant="circular" height={isMobile ? '4rem' : '5rem'} width={isMobile ? '4rem' : '5rem'} />
          </Grid>
          <Grid item xs>
            <Skeleton variant="rectangular" height="1.5rem" width="15rem" />
            <Skeleton variant="text" width="10rem" />
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={2.5}>
        <Grid item xs>
          <Box>
            <Skeleton sx={{ mb: 3 }} variant="rectangular" height="1.5rem" width="15rem" />
            <Grid container spacing={1.5} direction="column">
              <Grid item>
                <Skeleton variant="rectangular" width="100%" height="1rem" />
              </Grid>
              <Grid item>
                <Skeleton variant="rectangular" width="100%" height="1rem" />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
